import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useAuthentication from '@/composables/useAuthentication'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

  const { arrowRight, checkmark } = useIcons()
  const { requestingResetPassword, requestResetPassword } = useAuthentication()
  const { translateString } = useI18n()
  const { isKetchUpCompany } = useCommonMixin()
  const email = ref('')
  const showSuccessMessage = ref(false)

  const triggerResetPassword = () => {
    if (email.value) {
      requestResetPassword(email.value)
    } else {
      eventBus.$toasted.error(translateString('onboarding.pleaseEnterEmail'))
    }
  }

  watch(requestingResetPassword, (value: boolean) => {
    if (!value) {
      showSuccessMessage.value = true
    }
  })

return { __sfc: true,arrowRight, checkmark, requestingResetPassword, requestResetPassword, translateString, isKetchUpCompany, email, showSuccessMessage, triggerResetPassword, ref, watch, KetchUpButton, SVGRenderer, useIcons, LoadingSpinner, useAuthentication, eventBus, useI18n, useCommonMixin }
}

})